import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { BrandImage } from "components/brand-image";
import { SignupLayout } from "./signup.layout";
import { Step1, CompleteSignup, CompleteSignup2 } from "./steps";

const SignupMain = ({ apiKey }) => {
   const router = useRouter();
   const query = router.query;
   console.log(Number(router.query?.step));

   console.log(apiKey, "apikey");

   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);
   return (
      <SignupLayout>
         <div className="overflow">
            <div className="brand-wrapper">
               <BrandImage />
            </div>
            {(query && Object.keys(query).length === 0) || query?.ref ? (
               <Step1 />
            ) : query?.integration === "shopify" ? (
               <CompleteSignup />
            ) : (
               <CompleteSignup2 />
            )}
         </div>
      </SignupLayout>
   );
};

export { SignupMain };
